import React from "react";
import type { ContentCarouselSlide } from "@/types/content";
import { IntroSlide } from "./IntroSlide";
import { TextImageSlide } from "./TextImageSlide";
import { FullImageSlide } from "./FullImageSlide";

interface SlideRendererProps {
  slide: ContentCarouselSlide;
  /** Index of the slide (0-based), used for lazy loading decisions */
  index: number;
}

/**
 * Dispatches to the correct slide component based on the slideType discriminator.
 * Uses a switch statement for TypeScript exhaustiveness checking.
 */
export const SlideRenderer: React.FC<SlideRendererProps> = ({
  slide,
  index,
}) => {
  const lazy = index > 0;

  switch (slide.slideType) {
    case "intro":
      return <IntroSlide slide={slide} />;
    case "textImage":
      return <TextImageSlide slide={slide} lazy={lazy} />;
    case "fullImage":
      return <FullImageSlide slide={slide} lazy={lazy} />;
    default:
      return null;
  }
};
